import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { Model } from '../../../components/nlp/typesOld'
import { nlpModelsSelector } from '../../botNlp'

export function useNlpModels() {
  return useSelector<RootState, Model[]>(nlpModelsSelector)
}
